import gsap from 'gsap';
import toArray from '../../helpers/toArray';
import timeoutPromise from '../../helpers/timeoutPromise';

export default {
  namespace: 'article-detail',

  enter() {
    const sidebarCircles = document.querySelector('.sidebarCircles');

    if (sidebarCircles) {
      const circles = toArray(sidebarCircles.children);

      gsap.set(circles, {
        scale: 0.9,
        opacity: 0,
      });

      gsap.to(circles, {
        scale: 1,
        opacity: 1,
        duration: 1.5,
        ease: 'power2.out',
      });

      return timeoutPromise(400);
    }

    return Promise.resolve();
  },
};
